<template>
  <div id="year-slider" :class="browser">
    <div
      :class="
        $store.state.year <= 0 ? 'highlight selected' : 'highlight healthy'
      "
    ></div>
    <div
      :class="
        $store.state.year > 0 && $store.state.year < 6
          ? 'highlight selected early'
          : $store.state.year <= 0
          ? 'first'
          : 'highlight early'
      "
    ></div>
    <div
      :class="
        $store.state.year >= 6 && $store.state.year < 11
          ? 'highlight selected late'
          : $store.state.year <= 0
          ? 'first'
          : 'highlight late'
      "
    ></div>
    <div
      :class="
        $store.state.year >= 11
          ? 'highlight selected spms'
          : $store.state.year <= 0
          ? 'first'
          : 'highlight spms'
      "
    ></div>

    <div class="x-axis">
      <!-- <div class="fill" v-bind:style="{width: year/20*100 + '%'}"></div> -->
      <div class="ticks">
        <span
          v-for="n in 21"
          :key="'tick' + (n - 1)"
          class="tick"
          :class="{ active: $store.state.year == n - 1 }"
          v-bind:style="{ left: ((n - 1) / 20) * 100 + '%' }"
          >{{ n - 1 }}</span
        >
      </div>
    </div>
    <div class="slider-wrapper">
      <div
        v-show="$router.currentRoute.name === 'tutorial'"
        id="pulseDot"
        class="circle"
        :style="'left:' + `${dotPercent}` + '%'"
      ></div>
      <img
        id="sliderDot"
        src="../assets/img/slider-dot.svg"
        :style="'left:' + `${dotPercent}` + '%'"
      />

      <input
        name="year-slider"
        type="range"
        min="0"
        max="20"
        v-model="$store.state.year"
      />
      <div class="spacers">
        <span class="spacer spacer-0-1"></span>
        <span class="spacer spacer-5-6"></span>
        <span class="spacer spacer-10-11"></span>
      </div>
    </div>

    <div class="labels">
      <span
        @click="updateStageYear('healthy', 0)"
        class="label label-0"
        :class="$store.state.year <= 0 ? 'active' : ''"
      >
        <strong>Healthy</strong>
      </span>
      <span
        @click="updateStageYear('early-rrms', 3)"
        class="label label-3"
        :class="$store.state.year > 0 && $store.state.year < 6 ? 'active' : ''"
      >
        <strong>Early RRMS</strong> (1-5 years)<sup>†</sup>
      </span>
      <span
        @click="updateStageYear('late-rrms', 8)"
        class="label label-8"
        :class="
          $store.state.year >= 6 && $store.state.year < 11 ? 'active' : ''
        "
      >
        <strong>Late RRMS</strong> (6-10 years)<sup>†</sup>
      </span>
      <span
        @click="updateStageYear('spms', 15)"
        class="label label-15-16"
        :class="$store.state.year >= 11 ? 'active' : ''"
      >
        <strong>SPMS</strong> (10-20 years)<sup>†</sup>
      </span>
    </div>
  </div>
</template>

<script>
export default {
  name: "YearSlider",
  data() {
    return {
      browser: "",
      isChanging: false,
      dotPercent: 0,
    };
  },
  created() {
    if (this.$browserDetect.isIE) {
      this.browser = "ms";
    } else if (this.$browserDetect.isEdge) {
      this.browser = "edge";
    }
  },
  mounted() {
    let inputElement = document.querySelector('[type="range"]');

    inputElement.addEventListener("mousemove", this.handleMove);
    inputElement.addEventListener("mousedown", this.handleDown);
    inputElement.addEventListener("mouseup", this.handleUpAndLeave);
    inputElement.addEventListener("mouseleave", this.handleUpAndLeave);
    inputElement.addEventListener("click", this.setCSSProperty);

    inputElement.addEventListener("keydown", this.setCSSProperty);
    inputElement.addEventListener("keyup", this.setCSSProperty);

    inputElement.addEventListener("touchstart", this.handleDown);
    inputElement.addEventListener("touchend", this.setCSSProperty);
    inputElement.addEventListener("touchmove", this.setCSSProperty);

    this.setCSSProperty();
  },
  methods: {
    setCSSProperty(stagePer) {
      let inputElement = document.querySelector('[type="range"]');
      let percent = Math.round(
        ((inputElement.value - inputElement.min) /
          (inputElement.max - inputElement.min)) *
          100
      );

      inputElement.style.setProperty("--webkitProgressPercent", `${percent}%`);

      // Controls position of the sliderDot and pulseDot
      switch (percent) {
        case 0:
          this.dotPercent = percent - 1.2;
          break;
        case 5:
          this.dotPercent = percent - 1.2;
          break;
        case 10:
          this.dotPercent = percent - 1.3;
          break;
        case 15:
          this.dotPercent = percent - 1.3;
          break;
        case 20:
          this.dotPercent = percent - 1.4;
          break;
        case 25:
          this.dotPercent = percent - 1.4;
          break;
        case 30:
          this.dotPercent = percent - 1.5;
          break;
        case 35:
          this.dotPercent = percent - 1.5;
          break;
        case 40:
          this.dotPercent = percent - 1.6;
          break;
        case 45:
          this.dotPercent = percent - 1.6;
          break;
        case 50:
          this.dotPercent = percent - 1.6;
          break;
        case 55:
          this.dotPercent = percent - 1.6;
          break;
        case 60:
          this.dotPercent = percent - 1.6;
          break;
        case 65:
          this.dotPercent = percent - 1.7;
          break;
        case 70:
          this.dotPercent = percent - 1.7;
          break;
        case 75:
          this.dotPercent = percent - 1.8;
          break;
        case 80:
          this.dotPercent = percent - 1.8;
          break;
        case 85:
          this.dotPercent = percent - 1.9;
          break;
        case 90:
          this.dotPercent = percent - 1.9;
          break;
        case 95:
          this.dotPercent = percent - 2;
          break;
        case 100:
          this.dotPercent = percent - 2;
          break;
      }

      if (stagePer) {
        inputElement.style.setProperty(
          "--webkitProgressPercent",
          `${stagePer}%`
        );
      }
    },
    handleMove() {
      if (!this.isChanging) return;
      this.setCSSProperty();
    },
    handeUpAndLeave() {
      this.isChanging = false;
    },
    handleDown() {
      this.isChanging = true;
    },
    updateAnalytics(val) {
      if (val > 10) {
        this.$gtag.event("click", {
          event_category: "set_slider",
          event_label: `spms: ${val}`,
        });
      } else if (val > 5 && val < 11) {
        this.$gtag.event("click", {
          event_category: "set_slider",
          event_label: `late rrms: ${val}`,
        });
      } else if (val > 0 && val < 6) {
        this.$gtag.event("click", {
          event_category: "set_slider",
          event_label: `early rrms: ${val}`,
        });
      } else {
        this.$gtag.event("click", {
          event_category: "set_slider",
          event_label: "healthy",
        });
      }
    },
    updateStageYear(stage, val) {
      if (stage === "spms") {
        this.$store.updateYear(val);
        this.setCSSProperty(75);
      } else if (stage === "late-rrms") {
        this.$store.updateYear(val);
        this.setCSSProperty(40);
      } else if (stage === "early-rrms") {
        this.$store.updateYear(val);
        this.setCSSProperty(15);
      } else {
        this.$store.updateYear(val);
        this.setCSSProperty(0);
      }
    },
  },
  watch: {
    "$store.state.year": function (val) {
      // navigate to disease progression if on tutorial page change year if not on tutorial page
      if (this.$route.name === "tutorial" && val !== 0) {
        setTimeout(() => {
          this.$store.updateYear(0);
          this.$gtag.event("click", {
            event_category: `select_tutorial_slider`,
            event_label: "tutorial-slider",
          });
          this.$router.push("/disease-progression");
        }, 900);
      } else {
        this.$store.updateYear(val);
        this.updateAnalytics(this.$store.state.year);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
$toggleColor: $blue-dark-bg;
#sliderDot {
  position: absolute;
  z-index: 5;
  top: -8px;
  height: 33px;
  width: 33px;
  pointer-events: none;

  @media (max-width: 1679px) {
    margin-left: -8px;
  }

  &:focus {
    outline: 2.5px solid #ffd086;
  }

  &::before {
  }
}

#pulseDot {
  @media (max-width: 1679px) {
    margin-left: -8px;
  }
}

#year-slider {
  position: relative;
  background: $grey;
  padding: 0 rem(20px) rem(20px);
  z-index: 5;

  .highlight {
    top: -129px;
    background-color: rgba(237, 237, 237, 0.75);
    height: 100%;
    position: absolute;

    &.first {
      background-color: transparent;
    }

    &.selected {
      background-color: transparent;

      &:after {
        content: " ";
        position: absolute;
        bottom: -140px;
        left: 50%;
        transform: translateX(-50%);
        width: 0;
        height: 0;
        border-left: 20px solid transparent;
        border-right: 20px solid transparent;
        border-top: 20px solid #2a7dd1;
      }
    }

    @include breakpoint(lg) {
      top: -185px;
      height: 150%;
    }

    &.healthy {
      left: 0;
      width: 5%;
    }

    &.early {
      left: 5%;
      width: 23%;
    }
    &.late {
      left: 28%;
      width: 24%;
    }
    &.spms {
      left: 52%;
      width: 48%;
    }
  }

  // Custom range input styles

  input[type="range"] {
    position: relative;
    top: 0;
    left: -8px;
    width: calc(100% + 8px);
    background: transparent;
    height: 15px;
  }

  &.ms input[type="range"] {
    top: -14px;
  }

  &.edge input[type="range"] {
    top: 0;
  }

  // Base input range styles from http://danielstern.ca/range.css/#/

  input[type="range"] {
    -webkit-appearance: none;
    // width: 100%;
    margin: 0px 0;
    padding: 0 0 0 0;
    --webkitProgressPercent: 0%;
  }
  input[type="range"]:focus {
    outline: none;
    outline: 4px solid#FFD086;
    z-index: 1;
  }
  input[type="range"]:focus::-webkit-fill-lower {
    background: #d5d5d5;
  }
  input[type="range"]:focus::-webkit-fill-upper {
    background: #d5d5d5;
  }
  input[type="range"]::-moz-focus-outer {
    border: 0;
  }
  input[type="range"]::-moz-range-progress {
    background-color: $black;
    height: 9.2px;
  }
  input[type="range"]::-webkit-slider-runnable-track {
    width: 100%;
    height: 6px;
    cursor: pointer;
    box-shadow: 1px 1px 1px rgba(0, 0, 0, 0), 0px 0px 1px rgba(13, 13, 13, 0);
    background-color: $black;
    // background-image: url("../assets/img/slider-gradient-chrome.png");
    background-size: var(--webkitProgressPercent) 100%;
    background-repeat: no-repeat;
    border-radius: 1.3px;
    border: 0.2px solid rgba(198, 198, 198, 0);
    z-index: 1;
  }
  input[type="range"]::-webkit-slider-thumb {
    position: relative;
    height: 48px;
    width: 5%;
    cursor: pointer;
    -webkit-appearance: none;
    margin-top: -20px;
    background: none;
    border: none;
    box-shadow: none;
  }

  input[type="range"]:focus::-webkit-slider-thumb {
    // outline: 2.5px solid #ffd086;
    box-shadow: none;
  }

  input[type="range"]::-moz-range-track {
    width: 100%;
    height: 6px;
    cursor: pointer;
    box-shadow: 1px 1px 1px rgba(0, 0, 0, 0), 0px 0px 1px rgba(13, 13, 13, 0);
    background: $black;
    border-radius: 1.3px;
    border: 0.2px solid rgba(198, 198, 198, 0);
  }
  input[type="range"]::-moz-range-thumb {
    box-shadow: 1px 1px 1px rgba(0, 0, 0, 0), 0px 0px 1px rgba(13, 13, 13, 0);
    border: 0px solid #061c40;
    height: 24px;
    width: 16px;
    border-radius: 3px;
    background: #061c40;
    cursor: pointer;
  }
  input[type="range"]::-ms-track {
    width: 100%;
    height: 15px;
    cursor: pointer;
    background: transparent;
    border-color: transparent;
    color: transparent;
    margin: 14px;
  }
  input[type="range"]::-ms-fill-lower {
    background-color: $black;
    border: 0.2px solid rgba(198, 198, 198, 0);
    border-radius: 2.6px;
    box-shadow: 1px 1px 1px rgba(0, 0, 0, 0), 0px 0px 1px rgba(13, 13, 13, 0);
  }
  input[type="range"]::-ms-fill-upper {
    background: $black;
    border: 0.2px solid rgba(198, 198, 198, 0);
    border-radius: 2.6px;
    box-shadow: 1px 1px 1px rgba(0, 0, 0, 0), 0px 0px 1px rgba(13, 13, 13, 0);
  }
  input[type="range"]::-ms-thumb {
    box-shadow: 1px 1px 1px rgba(0, 0, 0, 0), 0px 0px 1px rgba(13, 13, 13, 0);
    border: 0px solid #061c40;
    height: 28px;
    width: 16px;
    border-radius: 3px;
    background: #061c40;
    cursor: pointer;
    position: relative;
  }

  &.edge input[type="range"]::-ms-thumb {
    margin-top: 0px;
  }

  input[type="range"]:focus::-ms-fill-lower {
    background-color: $black;
  }
  input[type="range"]:focus::-ms-fill-upper {
    background: #d5d5d5;
  }

  .x-axis {
    position: relative;
    width: calc(100% - 8px);
    left: 0;
    top: 0;
    // height: 24px;
    z-index: 100;
    pointer-events: none;
    // background: rgba(255,0,0,0.2);
    // outline: 2px solid red;
    * {
      pointer-events: none;
    }

    .ticks {
      display: block;
      height: 24px;
    }

    .tick {
      width: 20px;
      text-align: center;
      transform: translateX(-50%);
      position: absolute;
      top: 0px;
      color: $blue-dark-bg;
      font-size: rem(12px);

      &.active {
        font-weight: bold;
        &:before {
          content: " ";
          width: 2px;
          height: 108px;
          position: absolute;
          bottom: 24px;
          left: calc(50% - 1px);
          background: $blue-dark-bg;
        }
      }
    }

    .x-axis-label {
      position: relative;
      top: 0;
      width: 100%;
      text-align: center;
      color: $blue-dark-bg;
    }
  }

  .slider-instruction {
    // width: 105%;
    // left: -33px;
    text-align: center;
    position: relative;
    background-image: url("../assets/img/slider-inst-bg-left.svg"),
      url("../assets/img/slider-inst-bg-right.svg");
    background-repeat: no-repeat, no-repeat;
    background-position: center left, center right;
    height: 40px;
    margin-bottom: 10px;

    .slider-container {
      display: flex;
      align-items: center;
      justify-content: center;
      height: 20px;
      background-color: $white;
      width: 66%;
      margin: 0 auto;
      p {
        font-size: rem(17px);
        font-weight: $font-weight-bold;
        margin: 0 15px;
      }

      .slider-arrows {
        width: 19px;

        &.left {
          transform: scaleX(-1);
        }
      }
    }
  }

  .slider-wrapper {
    position: relative;
    width: 100%;
    height: 35px;

    .circle {
      opacity: 0;
      animation: pulse 2s ease-in 2s infinite;
      border: 2px solid $red;
      border-radius: 50%;
      transform-origin: center center;
      position: absolute;
      top: -22%;
      left: 0;
      z-index: 100;
      transform: translateY(50%);
      pointer-events: none;

      width: 33px;
      height: 33px;
    }

    @keyframes pulse {
      0% {
        opacity: 0;
        transform: scale(1);
      }

      15% {
        opacity: 0.5;
      }

      100% {
        opacity: 0;
        transform: scale(1.5);
      }
    }
  }

  .spacers {
    position: absolute;
    top: -4px;
    width: calc(100% - 8px);
    height: 24px;
    z-index: 1;
    pointer-events: none;
  }

  .spacer {
    position: absolute;
    width: 5px;
    height: 100%;
    top: 0px;
    transform: translateX(-50%);
    background: $grey;

    &.spacer-0-1 {
      left: percentage(1/40);
    }

    &.spacer-5-6 {
      left: percentage(11/40);
    }
    &.spacer-10-11 {
      left: percentage(21/40);
    }
  }

  .labels {
    position: relative;
    width: calc(100% - 12px);
    height: 2rem;
    left: 6px;
    // margin-top: 1.5rem;

    .label {
      position: absolute;
      bottom: 0;
      text-align: center;
      transform: translateX(-50%);
      color: $blue-dark-bg;
      font-size: rem(12px);
      border: 1px solid $blue-light;
      padding: 5px;
      border-radius: 5px;
      &.active {
        border: 1px solid transparent;
        strong {
          color: $blue-light;
        }
      }
      strong {
        font-weight: $font-weight-reg;
        color: $blue-dark-bg;
      }

      &:before {
        content: " ";
        display: block;
        width: 1px;
        height: 10px;
        position: absolute;
        left: 50%;
        top: -15px;
        background: $blue-dark-bg;
      }

      &.label-0 {
        left: rem(-6px);
        &.active {
          color: $blue-light;
        }
      }
      &.label-3 {
        left: calc(#{percentage(6/40)} - 6px);
        &.active {
          color: $blue-light;
        }
      }
      &.label-8 {
        left: calc(#{percentage(16/40)} - 4px);
        &.active {
          color: $blue-light;
        }
      }
      &.label-15-16 {
        left: percentage(31/40);
        &.active {
          color: $blue-light;
        }
      }
    }
  }
}
</style>